import AuthService from '../services/auth.service';
import EventBus from "../common/EventBus";

const user = localStorage.getItem('access');
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: { ...initialState, reauthRequired: false, reauthUserId: '', recoveryPendingCount: 0 },
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          EventBus.dispatch('loginsuccess');
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    refreshAccessToken({ commit }) {
      AuthService.refreshAccessToken();
      //commit('refreshed');
    },
    expired({ commit }) {
      AuthService.expired();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken);
    }
  },
  mutations: {
    setRecoveryPendingCount(state, count) {
      state.recoveryPendingCount = count;
    },
    requireReauth(state, userId) {
      state.reauthRequired = true;
      state.reauthUserId = userId;
    },
    loginSuccess(state, user) {
      state.reauthRequired = false;
      state.reauthUserId = '';
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.reauthRequired = false;
      state.reauthUserId = '';
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    refreshToken(state, accessToken) {
      state.status.loggedIn = true;
      state.user = { ...state.user, accessToken: accessToken };
    }
  }
};
